import React from 'react';
import Input from '../../../components/ui/Input';

function SlugFilter({ value, onChange, disabled = false }) {
  return (
    <Input
      id="prompt-slug-filter"
      label="Buscar"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Ex.: knowledge_context, material, summarize"
      hint={disabled ? undefined : 'Busca parcial em slug, descrição e conteúdo'}
    />
  );
}

export default SlugFilter;
